import {Button, makeStyles, SvgIcon} from "@material-ui/core";
import {Play as PlayIcon} from "react-feather";
import React from "react";
import {useTranslation} from "react-i18next";

const useStyles = makeStyles((theme) => ({
	root: {},
	action: {
		marginBottom: theme.spacing(1)
	}
}));

export const TriggerVerificationButton = ({onClick}) => {

	const { t } = useTranslation();
	const classes = useStyles();

    return (<Button
					color="secondary"
					variant="contained"
					className={classes.action}
                    onClick={onClick}
					startIcon={
						<SvgIcon fontSize="small">
							<PlayIcon />
						</SvgIcon>
					}
				>
                    {t('Trigger verification')}
				</Button>);
}